export const DEFAULT_SERVER_ERROR = 'Server error. PLease contact support.';

export const CANCELLED_REQUEST_ERROR = 'Request was cancelled.';
